import { fromEvent, map } from 'rxjs';
import { store } from '@redux/store';
import { userProfileSlice } from '../redux/slices';

const actions = userProfileSlice.actions;

const updateNeustarInformation = (response) => store.dispatch(actions.updateNeustarInformation(response));

fromEvent(document.body, 'neustarLoaded')
  .pipe(map((event) => event.detail))
  .subscribe(updateNeustarInformation);
